module.exports = __webpack_public_path__ + "static/media/13.973b5681.jpg";